import { createFileRoute } from '@tanstack/react-router';
import { Domains } from '@/components/domains';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/domains',
)({
  component: DomainsSettings,
});

function DomainsSettings() {
  return (
    <PageContent>
      <Domains />
    </PageContent>
  );
}
